import store from "@/store";
import DepService from "@/services/depService";
import {getBrandConfig} from "@/brand";
import {GameToBrandMap} from "@/brand/brandConfig";

export async function userAuthenticate(to, from, next) {
    const urlParams = new URLSearchParams(window.location.search);
    const productId = urlParams.get('productId');
    const storedProductId = sessionStorage.getItem('productId');

    if (productId && productId !== store.state.productId) {
        store.commit('setProductId', productId);
        const brandId = GameToBrandMap.get(Number(productId));
        const brandConfig = brandId ? getBrandConfig(brandId) : getBrandConfig(4);
        store.commit('setBrandConfig', brandConfig);
    } else if (!productId && (storedProductId || store.state.productId) && !store.state.brandConfig) {
        const currentProductId = storedProductId || store.state.productId;
        const brandId = GameToBrandMap.get(Number(currentProductId));
        const brandConfig = brandId ? getBrandConfig(brandId) : getBrandConfig(4);
        store.commit('setProductId', currentProductId);
        store.commit('setBrandConfig', brandConfig);
    }

    if (to.name === 'SelectVoucher' && store.state.user) {
        return next();
    }

    const allowedRoutes = ['RequestOtp', 'TermsConditionsPage'];
    const encryptedMsisdn = urlParams.get('e-msisdn');

    if (encryptedMsisdn) return await encryptedMsisdnAuth(encryptedMsisdn, next);

    if (store.state.msisdn) return next();

    if (allowedRoutes.includes(to.name)) {
        return next();
    }

    if (!allowedRoutes.includes(to.name) && store.state.msisdn === undefined) {
        return next({name: 'RequestOtp'});
    }
}

async function encryptedMsisdnAuth(encryptedMsisdn, next) {
    try {
        const decryptMsisdnResponse = (await DepService.decryptMsisdn(encryptedMsisdn)).data;
        const userDataResponse = await getUser(decryptMsisdnResponse.rawMsisdn);
        await setUserData(userDataResponse.user);

        store.commit('setMsisdn', decryptMsisdnResponse.rawMsisdn);

        return redirectToSelectVoucher(store.state.user, next);
    } catch (error) {
        console.error("Authentication error:", error);
        return next({name: 'RequestOtp'});
    }
}

async function getUser(msisdn) {
    const {data: userResponse} = await DepService.getUserViaProductId(msisdn, store.state.productId);
    return userResponse;
}

async function setUserData(userDataResponse) {
    store.commit('setUser', userDataResponse);
}

function redirectToSelectVoucher(userStatus, next) {
    return next({name: 'SelectVoucher'});
}
